import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"
import { gql } from "@apollo/client"

export const getMovableSchedules = api((clientId, search) =>
    !clientId
        ? null
        : query(
              gql`
                  query GetMovableSchedules($clientId: String!, $search: String) {
                      getMovableSchedules(search: $search, clientId: $clientId) {
                          code
                          title
                          id
                          version
                      }
                  }
              `,
              {
                  clientId,
                  search,
              },
              {
                  returns: "getMovableSchedules",
              }
          )
)
